<template>
  <div v-if="authorized">
    <KTPortlet title="Add New Merchant">
      <template v-slot:body>
        <b-form @submit="onSubmit" @reset="onReset" v-if="show">
          <b-form-group label="Tenant Alias:" label-for="tenantAlias">
            <b-form-input
              id="tenantAlias"
              v-model="$v.form.code.$model"
              required
              placeholder="Enter tenant alias"
              :state="validateState('code')"
              aria-describedby="tenantAlias-error"
            ></b-form-input>
            <b-form-invalid-feedback id="tenantAlias-error">
              Tenant Alias is required and must not be less than 5 characters.
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Contact Name:" label-for="contactName">
            <b-form-input
              id="contactName"
              v-model="$v.form.name.$model"
              required
              placeholder="Enter contact name"
              :state="validateState('name')"
              aria-describedby="contactName-error"
            ></b-form-input>
            <b-form-invalid-feedback id="contactName-error">
              Contact Name is required and must not be less than 3 characters.
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Contact Email:" label-for="contactEmail">
            <b-form-input
              id="contactEmail"
              v-model="$v.form.email.$model"
              type="email"
              required
              placeholder="Enter contact email"
              :state="validateState('email')"
              aria-describedby="contactEmail-error"
            ></b-form-input>
            <b-form-invalid-feedback id="contactEmail-error">
              Contact Email is required and must be a valid email address.
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Merchant Site:" label-for="merchantSite">
            <b-form-input
              id="merchantSite"
              v-model="$v.form.url.$model"
              type="url"
              required
              placeholder="https://pay.merchant.com/"
              :state="validateState('url')"
              aria-describedby="merchantSite-error"
            ></b-form-input>
            <b-form-invalid-feedback id="merchantSite-error">
              Merchant Site is required and must be a valid URL.
            </b-form-invalid-feedback>
          </b-form-group>

          <b-button type="submit" variant="primary">Submit</b-button>
          <b-button type="reset" variant="danger">Reset</b-button>
        </b-form>
      </template>
    </KTPortlet>
    <LoadingModal v-bind="loadingModal" />
    <AlertModal
      v-bind="alertModal"
      v-model="alertModal.show"
      @dismiss="resetAlert"
    />
  </div>
</template>

<script>
import KTPortlet from "@/views/partials/content/Portlet";
import { API, graphqlOperation } from "aws-amplify";
import AlertModalMixin from "@/components/widgets/AlertModalMixin.js";
import { validationMixin } from "vuelidate";
import { email, minLength, required, url } from "vuelidate/lib/validators";

const AlertModal = AlertModalMixin.AlertModal;
const LoadingModal = AlertModalMixin.LoadingModal;

export default {
  mixins: [validationMixin, AlertModalMixin],
  components: {
    KTPortlet
  },
  data: () => {
    return {
      form: {
        name: null,
        email: null,
        code: null,
        url: null
      },
      show: true
    };
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      code: {
        required,
        minLength: minLength(5)
      },
      name: {
        required,
        minLenght: minLength(3)
      },
      url: {
        required,
        url
      }
    }
  },
  computed: {
    authorized() {
      return this.$role.verify(["Admin"]);
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit: async function(e) {
      e.preventDefault();
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const name = this.form.name;
      const email = this.form.email;
      const tenantAlias = this.form.code;
      const url = this.form.url;

      let requestMessage = `Successfully OnBoarded ${tenantAlias}.\nAn email with temporary credentials has been sent to ${email}`;
      let alertType = AlertModal.SUCCESS;

      try {
        this.startLoadingDialog(`OnBoarding ${tenantAlias}`);
        const result = await this.onBoardMerchant(
          name,
          email,
          tenantAlias,
          url
        );
        if (!result) {
          requestMessage = `There was an error OnBoarding ${tenantAlias}. (error code: 01)`;
          alertType = AlertModal.ERROR;
        } else this.onReset();
      } catch (e) {
        this.$logger.error(e);
        requestMessage = `There was an error OnBoarding ${tenantAlias}. (error code: 02)`;
        alertType = AlertModal.ERROR;
      }
      this.stopLoadingDialog(requestMessage, alertType);
    },
    onReset: function() {
      this.form.name = null;
      this.form.email = null;
      this.form.code = null;
    },
    async onBoardMerchant(name, adminEmailAddress, merchantCode, url) {
      if (!this.authorized) return false;

      const onBoardMerchant = `
          mutation OnBoardMerchant($body: MutationOnBoardMerchantBodyInput) {
            onBoardMerchant(body: $body)
          }
        `;

      const body = {
        newMerchant: {
          merchantCode,
          adminEmailAddress,
          name,
          url
        }
      };
      try {
        const response = await API.graphql(
          graphqlOperation(onBoardMerchant, { body })
        );
        return response.data.onBoardMerchant;
      } catch (e) {
        throw e;
      }
    }
  }
};
</script>

<style></style>
